import { apps } from '../rolesAndPermission';

export const moveItemModule = {
  ticket: {
    id: 18,
    moduleName: 'Ticket',
  },
} as const;

export const moveItemFeatures = {
  'move-item': {
    id: 239,
    createdBy: 'System',
    featureName: 'Move Item',
  },
} as const;

export const moveItemFeaturesList = Object.entries(moveItemFeatures).map(([key, v]) => ({
  key,
  ...v,
}));

export const moveItemModules = [{ appId: apps.dashboard.id, moduleId: moveItemModule['ticket'].id }];

export const moveItemModuleFeatures = [
  { moduleId: moveItemModule['ticket'].id, featureId: moveItemFeatures['move-item'].id },
];
